export default __webpack_public_path__ + "static/media/tred-placeholder.d63bf7c0.jpg";